import {
   Fulfillment 
} from './fulfillment.wms.model';

import {
  RateGroupWms
} from './rate-group.wms.model';

import {
  Service
} from './service.model';

import {
  Translation
} from './translation.model';

import {
  User
} from './user.jwt.model';

export class PricelistWms {
  _id?: string;
  context?: string;
  currencyCode: string;
  currencySymbol: string;
  isDraft: boolean = true;
  averageMonthlyConsignments?: number;
  internal?: string;
  label: string;
  labelHuman?: string;
  ownerEmail: string;
  partnerCode?: string;
  rateCurrency?: string;
  rateGroups: RateGroupWms[] = [];
  documentTemplate: string = '';
  services: Service[]|string[];
  users: User[]|string[];
  terms?: string;
  translations: Translation[] = [];
  validTimestampStart?: Date;
  validTimestampEnd?: Date;
  vatRate: number;
  warehouse: string;
  hasSameExtraSKU?: boolean;
  countryCode?: string;

  constructor(
    currencyCode: string,
    currencySymbol: string,
    ownerEmail: string,
    services: Service[]
  ) {
    this.currencyCode = currencyCode;
    this.currencySymbol = currencySymbol;
    this.ownerEmail = ownerEmail;
    this.services = services;
  }
};
